import { eligibleForQuoteComparison, OfferStatusIdType } from '../../constants/StatusMap';

export const MAX_COMPARE_SELECTIONS = 3;
export const MIN_COMPARE_SELECTIONS = 2;

// Checks whether the selected offer is eligible for comparison based on its current offer status.
export const isSelectedOfferEligible = (
  allQuotesData: QuoteSchema.Schemas.QuoteResponse[],
  selectedOfferId: string
): boolean => {
  const quote = allQuotesData.find((quote) =>
    quote?.financialProduct?.offers?.some((offer) => offer.offerId === selectedOfferId)
  );

  if (!quote) {
    return false;
  }

  const offerStatusId = quote.financialProduct?.offers?.[0].statusId;

  return !!offerStatusId && eligibleForQuoteComparison.includes(offerStatusId as OfferStatusIdType);
};
